import { Administrator } from '@favid-inc/api';
import { Action } from 'core/generic';
import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { EmptyList } from 'utils';
import { deleteAdmin } from './claim/controller';
import { ModalConfirmRemoveAdm } from './ModalConfirmRemoveAdm';

interface Params {
  list: Administrator[];
  dispatch: (action: Action) => void;
}

interface State {
  isModalOpen: boolean;
  selectedAdministrator?: Administrator;
}

class List extends React.Component<Params> {
  state: State = {
    isModalOpen: false,
  };

  onConfirmDelete = () => {
    const { selectedAdministrator } = this.state;
    if (selectedAdministrator) {
      deleteAdmin(selectedAdministrator, this.props.dispatch);
    }
  };

  onShowModalDeleteCategoria = (event: React.SyntheticEvent<HTMLElement>) => {
    const email = event.currentTarget.dataset.value || '';
    const index = _.map(this.props.list).findIndex((adm) => adm.email === email);
    const selectedAdministrator = this.props.list[index];
    this.setState({ selectedAdministrator, isModalOpen: true });
  };

  onHideModalDeleteCategoria = () => {
    this.setState({ selectedAdministrator: undefined, isModalOpen: false });
  };

  renderList() {
    return this.props.list.map(({ id, email }) => (
      <div key={`admin_${id}`} className='column'>
        <Container className='ui action input'>
          <input className='Read Only' value={email} readOnly={true} />
          <button data-value={email} onClick={this.onShowModalDeleteCategoria}>
            <i className='trash icon' />
          </button>
        </Container>
      </div>
    ));
  }

  render() {
    const { list } = this.props;
    if (list.length === 0) {
      return <EmptyList message='Lista de categorias vazia.' />;
    }

    const { isModalOpen, selectedAdministrator } = this.state;
    if (isModalOpen && selectedAdministrator) {
      return (
        <ModalConfirmRemoveAdm
          administrator={selectedAdministrator}
          onCloseModal={this.onHideModalDeleteCategoria}
          onConfirmDelete={this.onConfirmDelete}
        />
      );
    }

    return (
      <div className='ui segment'>
        <div className='ui header'>
          <h3>Listagem de administradores</h3>
        </div>
        <div className='ui one column grid'>{this.renderList()}</div>
      </div>
    );
  }
}

export const ListAdmins = List;

const Container = styled.div`
  width: 100%;
  margin: 0.5em 0;
`;
